module.exports = __webpack_public_path__ + "static/img/banner_recruit_02.17efa70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/banner_recruit_02.png
// module id = gnGl
// module chunks = 10